import {
  pairingInteraction,
  productInteraction,
  type AccessedFrom,
  type FeedInteractionFields,
  type Location,
} from '@hungryroot/segment';

/**
 * Spreads {@link FeedInteractionFields} — where the Exp 242 nav/IA logging
 * spec's shared columns live (`container`, `carousel_id`, `carousel_name`,
 * `horizontal_position`, `content_type`, `recommendation_source`, …).
 *
 * Passed through wholesale rather than enumerated, so adding the next spec field
 * means editing `FeedInteractionFields` and the call site — not this file too.
 */
type Params = FeedInteractionFields & {
  id: number;
  name: string;
  category: 'pairings' | 'products';
  location: Location | null;
  state: boolean;
  orderId?: number;
  pageName?: string;
  accessedFrom?: AccessedFrom;
  conversationId?: string;
  searchId?: string;
  resultPosition?: number;
};

export function trackFavorite(params: Params) {
  const {
    id,
    name,
    category,
    location,
    state,
    orderId,
    pageName,
    accessedFrom,
    conversationId,
    searchId,
    resultPosition,
    ...feedFields
  } = params;

  // No local `tab` derivation: `productInteraction`/`pairingInteraction` now
  // resolve it themselves via `resolveInteractionTab`, so a caller's explicit
  // `tab` (spread below with the rest of `feedFields`) still wins and every
  // other caller gets the route fallback for free. Deriving it here as well
  // would be a second copy of the same fallback.
  switch (category) {
    case 'pairings': {
      pairingInteraction({
        ...feedFields,
        pairingId: id,
        pairingName: name,
        actionType: state ? 'saved' : 'unsaved',
        location,
        orderId,
        pageName,
        accessedFrom,
        conversationId,
        searchId,
        resultPosition,
      });

      break;
    }

    case 'products': {
      productInteraction({
        ...feedFields,
        productId: id,
        productName: name,
        actionType: state ? 'saved' : 'unsaved',
        location,
        orderId,
        pageName,
        accessedFrom,
        conversationId,
        searchId,
        resultPosition,
      });

      break;
    }
  }
}
